
import { Question } from '../types';

export const taj101VowelsQuestions: Question[] = [
  {
    id: 'taj011',
    text: 'What are the three main vowels (ḥarakāt) in Arabic?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Fatḥah', isCorrect: true },
      { id: 'b', text: 'Kasrah', isCorrect: true },
      { id: 'c', text: 'Ḍammah', isCorrect: true },
      { id: 'd', text: 'Sukūn', isCorrect: false }
    ],
    explanation: 'The three main vowels (ḥarakāt) in Arabic are Fatḥah (a small diagonal stroke above a letter), Kasrah (a small diagonal stroke below a letter), and Ḍammah (a small wāw above a letter).',
    topic: 'taj101'
  },
  {
    id: 'taj012',
    text: 'What is indicated by a sukūn in Arabic text?',
    type: 'single',
    options: [
      { id: 'a', text: 'The absence of a vowel sound (ḥarakah)', isCorrect: true },
      { id: 'b', text: 'A doubled consonant', isCorrect: false },
      { id: 'c', text: 'A long vowel', isCorrect: false },
      { id: 'd', text: 'A pause in recitation', isCorrect: false }
    ],
    explanation: 'The sign indicating the absence of a ḥarakah is written directly above a letter (ْ). This is called a sukūn, and it indicates that the letter has no vowel sound.',
    topic: 'taj101'
  },
  {
    id: 'taj013',
    text: 'What is a letter called if it has or carries a ḥarakah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Mutaḥarrik', isCorrect: true },
      { id: 'b', text: 'Sākin', isCorrect: false },
      { id: 'c', text: 'Mushaddad', isCorrect: false },
      { id: 'd', text: 'Munawwan', isCorrect: false }
    ],
    explanation: 'A letter which has or carries a ḥarakah is called mutaḥarrik. If it bears a sukūn, it is called sākin.',
    topic: 'taj101'
  },
  {
    id: 'taj014',
    text: 'What does the tashdīd or shaddah (َّ) indicate in Arabic text?',
    type: 'single',
    options: [
      { id: 'a', text: 'The letter is doubled (geminated)', isCorrect: true },
      { id: 'b', text: 'The letter is silent', isCorrect: false },
      { id: 'c', text: 'The letter has no vowel', isCorrect: false },
      { id: 'd', text: 'The letter is pronounced with emphasis', isCorrect: false }
    ],
    explanation: 'The sign (َّ) is called a tashdīd or shaddah, and the letter which bears a tashdīd is called mushaddad. The mushaddad letter is pronounced twice: the first one always as sākin and the second one with a ḥarakah.',
    topic: 'taj101'
  },
  {
    id: 'taj015',
    text: 'How is a letter with tashdīd (mushaddad) pronounced?',
    type: 'single',
    options: [
      { id: 'a', text: 'As two letters: first sākin, then with a ḥarakah', isCorrect: true },
      { id: 'b', text: 'With a prolonged vowel sound', isCorrect: false },
      { id: 'c', text: 'With a nasal sound', isCorrect: false },
      { id: 'd', text: 'With emphasis (tafkhīm)', isCorrect: false }
    ],
    explanation: 'The mushaddad letter is pronounced twice: the first one always as sākin and the second one with a ḥarakah. For example, (مَرَّ) is read as (مَرْرَ).',
    topic: 'taj101'
  },
  {
    id: 'taj016',
    text: 'What does tanwīn mean in Arabic?',
    type: 'single',
    options: [
      { id: 'a', text: 'Adding a nūn sākinah to the end of nouns', isCorrect: true },
      { id: 'b', text: 'Doubling the last letter of a word', isCorrect: false },
      { id: 'c', text: 'Removing the final vowel', isCorrect: false },
      { id: 'd', text: 'Making a letter emphatic', isCorrect: false }
    ],
    explanation: 'Tanwīn means to add a nūn sākinah (to the end of nouns). Even though this extra nūn sākinah is not written (نْ), it is pronounced.',
    topic: 'taj101'
  },
  {
    id: 'taj017',
    text: 'How is tanwīn indicated in written Arabic?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Double fatḥah (ًَ)', isCorrect: true },
      { id: 'b', text: 'Double kasrah (ٍَ)', isCorrect: true },
      { id: 'c', text: 'Double ḍammah (ٌَ)', isCorrect: true },
      { id: 'd', text: 'Sukūn (ْ)', isCorrect: false }
    ],
    explanation: 'Tanwīn is indicated by means of a double fatḥah (ًَ), a double kasrah (ٍَ) or a double ḍammah (ٌَ) and is pronounced as ʾan (أَنْ), ʾin (إِنْ) and ʾun (أُنْ) respectively.',
    topic: 'taj101'
  },
  {
    id: 'taj018',
    text: 'How is a word with double fatḥah (tanwīn fatḥ) pronounced?',
    type: 'single',
    options: [
      { id: 'a', text: 'With an added "an" sound at the end', isCorrect: true },
      { id: 'b', text: 'With an added "in" sound at the end', isCorrect: false },
      { id: 'c', text: 'With an added "un" sound at the end', isCorrect: false },
      { id: 'd', text: 'With a doubled final consonant', isCorrect: false }
    ],
    explanation: 'A word with double fatḥah (tanwīn fatḥ) is pronounced with an added "an" sound at the end. For example, رَحْمَةً is pronounced as raḥmatan.',
    topic: 'taj101'
  },
  {
    id: 'taj019',
    text: 'What does istiʿādhah refer to in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Seeking refuge with Allah before reciting the Qur\'ān', isCorrect: true },
      { id: 'b', text: 'A specific letter pronunciation', isCorrect: false },
      { id: 'c', text: 'A mode of recitation', isCorrect: false },
      { id: 'd', text: 'A type of pause in recitation', isCorrect: false }
    ],
    explanation: 'Istiʿādhah means seeking refuge or protection. In Tajweed, it refers to reciting "aʿūdhu billāhi min ash-shayṭān ir-rajīm" (I seek refuge with Allah from Satan the accursed) before starting recitation of the Qur\'ān.',
    topic: 'taj101'
  },
  {
    id: 'taj020',
    text: 'What does the term basmalah refer to in Tajweed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Saying "bismillāh ir-raḥmān ir-raḥīm"', isCorrect: true },
      { id: 'b', text: 'A specific elongation rule', isCorrect: false },
      { id: 'c', text: 'A pause at the end of verses', isCorrect: false },
      { id: 'd', text: 'A type of recitation melody', isCorrect: false }
    ],
    explanation: 'The basmalah refers to saying "bismillāh ir-raḥmān ir-raḥīm" (In the name of Allah, the Most Gracious, the Most Merciful). It is recited when commencing the recitation of the Qur\'ān and particularly at the beginning of surahs.',
    topic: 'taj101'
  }
];
